<div class="dashboard-wrapper">
  <header class="asset-info-header">
    <div class="info-items-container">
      <div class="info-item">
        <span class="info-value">
          <span *ngIf="loadingCompanyDetails" class="skeleton skeleton-text-device-details"
            style="display: inline-block; width: 100px; height: 18px;"></span>
          <span *ngIf="!loadingCompanyDetails">{{companyName}}</span>
        </span>
        <span class="info-label">CUSTOMER</span>
      </div>

      <div class="info-item">
        <span class="info-value">
          <span *ngIf="loadingCompanyDetails" class="skeleton skeleton-text-device-details"
            style="display: inline-block; width: 90px; height: 18px;"></span>
          <span *ngIf="!loadingCompanyDetails">{{siteName}}</span>
        </span>
        <span class="info-label">SITE</span>
      </div>

      <div class="info-item">
        <span class="info-value">
          <span *ngIf="loadingCompanyDetails" class="skeleton skeleton-text-device-details"
            style="display: inline-block; width: 110px; height: 18px;"></span>
          <span *ngIf="!loadingCompanyDetails">{{applicationName}}</span>
        </span>
        <span class="info-label">APPLICATION</span>
      </div>

      <div class="info-item">
        <span class="info-value">
          <span *ngIf="loadingCompanyDetails" class="skeleton skeleton-text-device-details"
            style="display: inline-block; width: 120px; height: 18px;"></span>
          <span *ngIf="!loadingCompanyDetails">{{serialNumber}}</span>
        </span>
        <span class="info-label">MACHINE SERIAL NUMBER</span>
      </div>

      <div class="info-item">
        <span class="info-value">
          <span *ngIf="loadingCompanyDetails" class="skeleton skeleton-text-device-details"
            style="display: inline-block; width: 100px; height: 18px;"></span>
          <span *ngIf="!loadingCompanyDetails">{{assetName}}</span>
        </span>
        <span class="info-label">ASSET NAME</span>
      </div>
    </div>
  </header>
  <div class="dashboard-header" style="margin-bottom: 0rem !important; margin-top: 1rem !important;">
    <h1 class="dashboard-title">Machine Diagnostics</h1>
  </div>
  <!-- Machine Specs Section -->
  <div class="machine-params-line">

    <ng-container *ngIf="loadingRPM">
      <div class="param-pill skeleton" style="width: 100px; height: 24px;"></div>
      <div class="param-pill skeleton" style="width: 100px; height: 24px;"></div>
      <div class="param-pill skeleton" style="width: 100px; height: 24px;"></div>
    </ng-container>

    <ng-container *ngIf="!loadingRPM && rpmData">

      <ng-container *ngIf="isGear">
        <div class="param-pill">
          <span class="label">Pinion Rated RPM:</span>
          <span class="value">
            {{ rpmData.pinion?.rated_rpm ?? 'N/A' }} <small>RPM</small></span>
        </div>
        <div class="param-pill">
          <span class="label">Pinion Actual RPM:</span>
          <span class="value">
            {{ rpmData.pinion?.actual_rpm ?? 'N/A' }} <small>RPM</small></span>
        </div>
        <div class="param-pill">
          <span class="label">Output Rated RPM:</span>
          <span class="value">
            {{ rpmData.output?.rated_rpm ?? 'N/A' }} <small>RPM</small></span>
        </div>
        <div class="param-pill">
          <span class="label">Output Actual RPM:</span>
          <span class="value">
            {{ rpmData.output?.actual_rpm ?? 'N/A' }} <small>RPM</small></span>
        </div>
      </ng-container>

      <ng-container *ngIf="!isGear">

        <ng-container *ngIf="rpmData.rpm_toggle === 'fixed'">
          <div class="param-pill">
            <span class="label">Rated RPM:</span>
            <span class="value">
              {{ rpmData.rated_rpm ?? 'N/A' }} <small>RPM</small></span>
          </div>
          <div class="param-pill">
            <span class="label">Actual RPM:</span>
            <span class="value">
              {{ rpmData.actual_rpm ?? 'N/A' }} <small>RPM</small></span>
          </div>
        </ng-container>

        <ng-container *ngIf="rpmData.rpm_toggle !== 'fixed'">
          <div class="param-pill">
            <span class="label">Min Rated RPM:</span>
            <span class="value">
              {{ rpmData.min_rated_rpm ?? 'N/A' }} <small>RPM</small></span>
          </div>
          <div class="param-pill">
            <span class="label">Max Rated RPM:</span>
            <span class="value">
              {{ rpmData.max_rated_rpm ?? 'N/A' }} <small>RPM</small></span>
          </div>
          <div class="param-pill">
            <span class="label">Actual RPM:</span>
            <span class="value">
              {{ rpmData.actual_rpm ?? 'N/A' }} <small>RPM</small></span>
          </div>
        </ng-container>

        <ng-container *ngIf="data.assetType === 'MOTOR'">
          <div class="param-pill">
            <span class="label">Rated Freq:</span>
            <span class="value">
              {{ showFrequency ? rpmData.line_frequency : 'N/A' }}
              <small *ngIf="showFrequency">Hz</small>
            </span>
          </div>
          <!-- <div class="param-pill">
            <span class="label">Operating Freq:</span>
            <span class="value">
              {{ showFrequency ? rpmData.operating_freq : 'N/A' }}
              <small *ngIf="showFrequency">Hz</small>
            </span>
          </div> -->
        </ng-container>

      </ng-container>

      <div class="param-pill">
        <span class="label">KW Rating:</span>
        <span class="value">
          {{ rpmData.rated_power ?? 'N/A' }} <small>KW</small></span>
      </div>

    </ng-container>

    <ng-container *ngIf="!loadingRPM && !rpmData">
      <div class="text-muted small">No RPM data available</div>
    </ng-container>

  </div>




  <main class="dashboard-content">
    <div class="diagnostics-inner-tabs">
      <ul ngbNav #diagTabs="ngbNav" class="custom_tab nav-tabs diagnostics-inner-nav" [activeId]="active_inner_tab"
        (navChange)="onInnerNavChange($event)">

        <li [ngbNavItem]="'inner-1'">
          <a ngbNavLink>Diagnostics Summary</a>
          <ng-template ngbNavContent>
            <div class=""></div>
            <app-diagnostics-summary [data]="data" />
          </ng-template>
        </li>

        <li [ngbNavItem]="'inner-2'">
          <a ngbNavLink>Velocity Spectra</a>
          <ng-template ngbNavContent>
            <app-velocity-spectra [data]="data"></app-velocity-spectra>
          </ng-template>
        </li>

        <li [ngbNavItem]="'inner-3'">
          <a ngbNavLink>Acceleration Spectra</a>
          <ng-template ngbNavContent>
            <app-acceleration-spectra [data]="data"></app-acceleration-spectra>
          </ng-template>
        </li>

        <li [ngbNavItem]="'inner-4'" *ngIf="data.assetType === 'GEAR'">
          <a ngbNavLink>Cepstrum Analysis</a>
          <ng-template ngbNavContent>
            <app-cepstrum-spectra [data]="data"></app-cepstrum-spectra>
          </ng-template>
        </li>
        <li [ngbNavItem]="'inner-5'" *ngIf="data.bearingIsOn === 'true'">
          <a ngbNavLink>Bearing Analysis</a>
          <ng-template ngbNavContent>
            <app-bearing-analysis [data]="data"></app-bearing-analysis>
          </ng-template>
        </li>

      </ul>

      <div [ngbNavOutlet]="diagTabs" class="mt-3"></div>


      <!-- The actual tab content render area -->
    </div>
  </main>
</div>
